import { pos_handheld_video_id } from 'src/consts/resource';
const SectionContent = {
  topSection: {
    en: {
      poster: `${process.env.ASSETS_PREFIX}/products/products_pos_handheld.png`,
      title: 'Handheld POS System',
      description:
        'A powerful and portable device that fits in your palm, built-in scanner and receipt, and large brilliant touch screen to capture digital signature, allowing you to take payments anytime, anywhere.',
      youtubeVideoId: pos_handheld_video_id,
    },
    zh: {
      poster: `${process.env.ASSETS_PREFIX}/products/products_pos_handheld.png`,
      title: '手持POS',
      description: '一款功能强大且便携的掌上支付终端，让您随时随地都能点单、收款签单',
      youtubeVideoId: pos_handheld_video_id,
    },
  },
  advances: {
    en: {
      title: `Chowbus POS Handheld`,
      subTitle: `When innovation meets convenience`,
      featureList: [
        {
          image: `${process.env.ASSETS_PREFIX}/products/products_pos_handheld_feature_1.png`,
          imageAlt: 'No Chunky Hardware',
          title: 'No Chunky Hardware',
          description: 'A powerful and portable device that fits in your palm',
        },
        {
          image: `${process.env.ASSETS_PREFIX}/products/products_pos_handheld_feature_2.png`,
          imageAlt: 'Powerful and Portable ',
          title: 'Powerful and Portable ',
          description:
            'built-in scanner and receipt, and large brilliant touch screen to capture digital signature, allowing you to take payments anytime, anywhere',
        },
        {
          image: `${process.env.ASSETS_PREFIX}/products/products_pos_handheld_feature_3.png`,
          imageAlt: 'Fully-integrated',
          title: 'Fully-integrated',
          description: 'Enhances Chowbus POS, and Loyalty Program',
        },
      ],
    },
    zh: {
      title: `小身板，大能量`,
      subTitle: `Chowbus手持POS搭载强大系统，为您提供全面服务`,
      featureList: [
        {
          image: `${process.env.ASSETS_PREFIX}/products/products_pos_handheld_feature_1.png`,
          imageAlt: '便携的设备',
          title: '便携的设备',
          description: '轻便的iPad mini让POS设备更便携，让支付更轻松',
        },
        {
          image: `${process.env.ASSETS_PREFIX}/products/products_pos_handheld_feature_2.png`,
          imageAlt: '强大的系统',
          title: '强大的系统',
          description: '系统自动存储客户电子签名，提升结账效率，减少退款纠纷',
        },
        {
          image: `${process.env.ASSETS_PREFIX}/products/products_pos_handheld_feature_3.png`,
          imageAlt: '全套的服务',
          title: '全套的服务',
          description: '集成Chowbus POS系统，同步菜单、订单、会员等信息',
        },
      ],
    },
  },
  features: {
    en: {
      items: [
        {
          layout: 'row',
          direction: 'normal',
          title: '',
          cover: `${process.env.ASSETS_PREFIX}/products/products_pos_handheld_advance_1.png`,
          items: [
            { desc: 'Connects with Wi-Fi' },
            { desc: 'Sleek, easy-to-use interface' },
            { desc: 'Large brilliant touch screen to capture digital signature ' },
            { desc: 'Built-in scanner and receipt printer ' },
          ],
        },

        {
          layout: 'row',
          direction: 'reverse',
          title: '',
          cover: `${process.env.ASSETS_PREFIX}/products/products_pos_handheld_advance_2.png`,
          items: [
            { desc: 'Increase table turnover rate by 25% by collecting payment & tips at the table' },
            { desc: 'Increase Tips amount by 30% with an easy tips selection function ' },
            { desc: 'No manual tips input necessary after shift ends, and avoid all troubles and errors ' },
            { desc: 'Save customer digital signatures forever and reduce dispute rate by 50% ' },
          ],
        },
      ],
    },
    zh: {
      items: [
        {
          layout: 'row',
          direction: 'normal',
          title: '桌边结账体验提升翻台率',
          cover: `${process.env.ASSETS_PREFIX}/products/products_pos_handheld_advance_1.png`,
          items: [
            { desc: '手持POS内置读卡器和收据打印机，店员无需往返柜台打印小票、刷卡、打印收据' },
            { desc: '大大缩短顾客结账时间，提升顾客结账体验' },
            { desc: '提升25%的翻台率，有效减少后续顾客的等待时间' },
          ],
        },

        {
          layout: 'row',
          direction: 'reverse',
          title: '电子账单显著提升小费额',
          cover: `${process.env.ASSETS_PREFIX}/products/products_pos_handheld_advance_2.png`,
          items: [
            { desc: '通过系统设置建议小费和默认小费，小费有效提升30%' },
            { desc: '系统通过规则自动计算小费分配，无需手动计算员工的小费收入' },
            { desc: '永久保存顾客电子签名，将退款纠纷率降低 50%' },
          ],
        },
      ],
    },
  },
  customerVoiceInfos: [
    {
      img: `${process.env.ASSETS_PREFIX}/home/customervoice/customer-voice-jongrobbq.jpeg`,
      productLine: 'Handheld',
      desc: {
        zh: `Jongro BBQ作为美国最地道的韩国烤肉店，选择使用Chowbus手持POS，其功能强大且便携的设备，让顾客可以随时随地刷卡收款和电子签名，带给了顾客全新的支付体验。餐厅服务员和顾客都对Chowbus手持POS赞不绝口。`,
        en: `Jongro BBQ, an authentic experience to Korean BBQ, has been using Chowbus POS and POS Handheld for an improved customer and staff experience.`,
      },
      restaurantName: { zh: `Jongro BBQ`, en: `Jongro BBQ` },
      location: { zh: '纽约', en: 'New York' },
      link: '/business-types/korean-bbq/jongro-bbq',
    },
  ],
};

export default SectionContent;
